import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiServiceService } from '../api-service.service';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';
@Component({
  selector: 'app-govt-servers-page',
  templateUrl: './govt-servers-page.component.html',
  styleUrls: ['./govt-servers-page.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatIcon,
    MatTooltip,
    NgxPaginationModule,
    CommonSearchComponent,
    CommonPaginationComponent,
  ],
})
export class GovtServersPageComponent implements OnInit {
  page = 1;
  size = 10;
  searchText = '';
  totalLength = 0;
  govServersList = [];

  govtServersForm: FormGroup = this.formBuilder.group({
    searchGovernmentServers: new FormControl(''),
  });

  userPermission = [];

  govtServersUpdate = false;
  govtServersView = false;
  govtServersCreate = false;
  govtServersDelete = false;

  isDownloading = false;

  // storage listener for cross-tab sync
  private storageListener = (event: StorageEvent) => {
    if (event.key === 'downloadInProgress') {
      this.isDownloading = event.newValue === 'true';
    }
  };

  constructor(
    public apiMicroservice: ApiServiceService,
    private formBuilder: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.checkPermission();
    this.setGovernmentServerListForm();
    this.fetchGovtServerList();
    this.syncInitialDownloadState();
  }

  checkPermission() {
    this.userPermission = JSON.parse(
      this.apiMicroservice.decryptData(
        sessionStorage.getItem('userPermission') || '[]'
      )
    );
    this.userPermission.forEach(
      (element: {
        pageName: string;
        view: boolean;
        create: boolean;
        delete: boolean;
        update: boolean;
      }) => {
        if (
          element.pageName === 'Government Servers' &&
          element.view === false
        ) {
          this.navigateBack();
        }
        if (
          element.pageName === 'Government Servers' &&
          element.create === true
        ) {
          this.govtServersCreate = true;
        }
        if (
          element.pageName === 'Government Servers' &&
          element.delete === true
        ) {
          this.govtServersDelete = true;
        }
        if (
          element.pageName === 'Government Servers' &&
          element.update === true
        ) {
          this.govtServersUpdate = true;
        }
        if (
          element.pageName === 'Government Servers' &&
          element.view === true
        ) {
          this.govtServersView = true;
        }
      }
    );
  }

  syncInitialDownloadState() {
    // sync initial download state across tabs
    this.isDownloading = localStorage.getItem('downloadInProgress') === 'true';
    window.addEventListener('storage', this.storageListener);
  }

  setGovernmentServerListForm() {
    this.govtServersForm = this.formBuilder.group({
      searchGovernmentServers: new FormControl(''),
    });
  }

  fetchGovtServerList() {
    this.spinner.show();
    this.apiMicroservice
      .getGovtServerList(this.page, this.size, this.searchText)
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          this.govServersList = res.data.data;
          this.totalLength = res.data.totalItems;
          if (res.status) {
            this.apiMicroservice.openSnackbar(res.message);
          } else {
            this.apiMicroservice.openSnackbar(res.message);
          }
        },
        error: (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          this.apiMicroservice.openSnackbar(ERROR.error.message);
        },
      });
  }

  onPageChange(event: number) {
    this.page = event;
    this.fetchGovtServerList();
  }

  onSizeChange(event: number) {
    this.page = 1;
    this.size = event;
    this.fetchGovtServerList();
  }

  onSearch(event: string) {
    this.page = 1;
    this.searchText = event;
    this.fetchGovtServerList();
  }

  deleteState(id: string) {
    if (confirm('Are you sure to Delete')) {
      this.apiMicroservice.deleteGovtServer(id).subscribe({
        next: (res) => {
          if (res.status) {
            this.ngOnInit();
            this.apiMicroservice.openSnackbar(res.message);
          } else {
            this.apiMicroservice.openSnackbar(res.message);
          }
        },
        error: (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          this.apiMicroservice.openSnackbar(ERROR.error.message);
        },
      });
    }
  }

  viewState(id: string) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/govt-servers-add', id])
    );
    const fullUrl = window.location.origin + url;

    // Open the URL in a new tab
    window.open(fullUrl, '_blank');
  }

  downloadAllServerDetailsReport() {
    if (confirm('Are you sure?')) {
      // mark download in-progress and notify other tabs
      this.isDownloading = true;
      localStorage.setItem('downloadInProgress', 'true');

      this.apiMicroservice.openSnackbar(
        'Your file is being generated. Refreshing the page or logging out may interrupt the download.'
      );
      this.apiMicroservice.downloadAllServerDetailsReport().subscribe({
        next: (res) => {
          try {
            if (res?.status && res.fileDownloadUrl) {
              const link = document.createElement('a');
              link.href = res.fileDownloadUrl;
              link.download = ''; // let browser infer filename
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              this.apiMicroservice.openSnackbar('File ready for download');
            } else {
              this.apiMicroservice.openSnackbar(
                res?.message || 'File URL not available'
              );
            }
          } finally {
            // clear in-progress state
            this.isDownloading = false;
            localStorage.setItem('downloadInProgress', 'false');
          }
        },
        error: (ERROR: HttpErrorResponse) => {
          const example =
            ERROR.error.message ||
            'Download failed. Please contact server team.';
          this.apiMicroservice.openSnackbar(example);
          // clear in-progress state
          this.isDownloading = false;
          localStorage.setItem('downloadInProgress', 'false');
        },
      });
    }
  }

  AddNew() {
    this.router.navigate(['govt-servers-add']);
  }

  redirect(to: string): void {
    this.router.navigate([to]);
  }

  navigateBack() {
    this.apiMicroservice.back();
  }
}
